export default __webpack_public_path__ + "static/media/pav_dashboard.e0d2857c.jpeg";